import { render, staticRenderFns } from "./WFileDrop.vue?vue&type=template&id=57d12e20&scoped=true&"
import script from "./WFileDrop.vue?vue&type=script&lang=js&"
export * from "./WFileDrop.vue?vue&type=script&lang=js&"
import style0 from "./WFileDrop.vue?vue&type=style&index=0&id=57d12e20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d12e20",
  null
  
)

export default component.exports